import React, { useState } from "react";
import Skeleton from "components/skeleton";
import DownloadReport from "components/models/DownloadReport";
import { findIcon } from "views/dashboard/icons";
import { DateRangePicker } from "@ui";

const ProjectFilters = ({
  title,
  dateLabel,
  setDateRangePayload,
  projectStartDate = "",
  projectEndDate = "",
  showDatePicker = true,
  isProjectDetailsLoading = false,
}) => {
  const [showReportDownloadModal, setShowReportDownloadModal] = useState(false);

  const today = new Date();
  let endDateLimit = new Date(projectEndDate);

  const todayDate = new Date(
    today.getFullYear(),
    today.getMonth(),
    today.getDate()
  );
  const endDateOnly = new Date(
    endDateLimit.getFullYear(),
    endDateLimit.getMonth(),
    endDateLimit.getDate()
  );

  if (endDateOnly.getTime() >= todayDate.getTime()) {
    endDateLimit = new Date(
      today.getFullYear(),
      today.getMonth(),
      today.getDate() - 1
    );
  }

  const handleOpenModal = () => {
    setShowReportDownloadModal(true);
  };
  const handleCloseModal = () => {
    setShowReportDownloadModal(false);
  };

  return (
    <>
      <div className="d-flex align-items-center gap-3 flex-wrap">
        <div className="form-group mb-0 d-flex">
          {!isProjectDetailsLoading ? (
            showDatePicker && (
              <DateRangePicker
                startDate={projectStartDate}
                projectEndDate={projectEndDate}
                endDate={endDateLimit}
                setDateRangePayload={setDateRangePayload}
                dateLabel={dateLabel}
              />
            )
          ) : (
            <Skeleton className="m-0" width={220} height={55} />
          )}
        </div>
        {["Summary", "Location Insights"].includes(title) && (
          <div>
            <button className="btn btn-success" onClick={handleOpenModal}>
              <span className="me-2">
                {findIcon("DownloadReport", "dual-tone", "18")}
              </span>
              Download Report
            </button>
          </div>
        )}
      </div>

      <DownloadReport
        heading="Export Campaign Report"
        reportType="Campaigns"
        show={showReportDownloadModal}
        handleClose={handleCloseModal}
      />
    </>
  );
};

export default ProjectFilters;
